<template>
  <el-form ref="form" label-position="top" :model="form" :rules="rules" label-width="120px" class="app-container view-container">
    <BjDivider>
      {{ $t('CustomerFunction.common.warehouseAdd') }}
      <template slot="right">
        <el-button @click="tryCancel()">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="onConfirm">{{ $t('okText') }}</el-button>
      </template>
    </BjDivider>
    <template>
      <el-row :gutter="10">
        <el-col :span="colSpan" v-if="!this.$store.getters.cusId">
          <el-form-item :label="$t('billingPage.CustomerName')">
            <BjSelectLov v-model="form.clientCode" :option-list="clientCodeList" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('CustomerFunction.common.logisticsNo')">
            <BjInput v-model="form.logisticsNumber" type="text" :placeholder="$t('inputText')" :disabled="true" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('CustomerFunction.common.associatedCode')" prop="">
            <BjInput v-model="form.associatedCode" type="text" :placeholder="$t('chooseText')" :disabled="true" clearable />
          </el-form-item>
        </el-col>
      </el-row>
    </template>
    <div class="bj-row mt20">
      <BjDivider>{{ $t('AddingAnInternalReturnRefundDoc.Product') }}
        <template>
          <el-button type="primary" @click="handleShowFnForDialogSkuList">{{$t('BusinessAfterCsgReturn.table.add') }}</el-button>
        </template>
      </BjDivider>
      <div class="bj-col bj-col-24" style="border-left:none">
        <el-table :data="form.confirmSkuList" border script max-height="600px">
          <el-table-column :label="$t('table.countText')" type="index" width="55" align="center" />
          <el-table-column prop="sku" label="SKU" align="center" />
          <el-table-column prop="barCode" :label="$t('BusinessPurchaseDetailPage.table.Barcode')" align="center" />
          <el-table-column prop="returnTotal" :label="$t('UploadTotalText')" align="center" />
          <el-table-column align="center">
            <template #header>
              <span class="red">*</span> {{ $t('CustomerFunction.common.Quantityof') }}
            </template>
            <template v-slot="{ row }">
              <BjInputNumber v-model="row.nonDefectiveNumber" class="full-width" clearable :controls="false" />
            </template>
          </el-table-column>
          <el-table-column prop="nonDefectiveHandling" :label="$t('CustomerFunction.table.GoodQuality')" align="center">
            <template v-slot="{ row }">
                {{$t(CSG_RETURN_LIST_ADMIN_STATUS.bjGet(row.nonDefectiveHandling)) }}
            </template>
          </el-table-column>
          <el-table-column align="center">
            <template #header>
              <span class="red">*</span> {{ $t('CustomerFunction.common.Quantityofdefective') }}
            </template>
            <template v-slot="{ row }">
              <BjInputNumber v-model="row.defectiveNumber" class="full-width" clearable :controls="false" />
            </template>
          </el-table-column>
          <el-table-column prop="defectiveHandling" :label="$t('CustomerFunction.table.HandlingOf')" align="center">
            <template v-slot="{ row }">
                {{$t(CSG_RETURN_LIST_ADMIN_STATUS.bjGet(row.defectiveHandling)) }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.operationText')" fixed="right" align="center" width="110">
            <template v-slot="{ $index }">
              <el-button @click="onDelete($index)">{{ $t('delText') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <BjDivider>{{ $t('AddingAnInternalReturnRefundDoc.Picture') }}</BjDivider>
    <div class="mt20">
      <el-form-item style="display: block; height: 100%">
        <BjUpload ref="BjUpload" class="avatar-uploader" :limit="3" :limit-size="5 * 1024" multiple show-file-list list-type="picture-card" accept="image/png,image/jpeg" :accept-list="['image/jpeg', 'image/png']" auto-upload limit-hide @afterUpload="afterUpload" @remove="onRemoveUrl">
          <template slot="default">
            <i class="el-icon-plus avatar-uploader-icon" />
          </template>
        </BjUpload>
      </el-form-item>
    </div>
    <BjDialogList ref="dialogList" :colSpan="8" :config="$BjDialogListConfig.skuDefault('SelectSKUText', { defaultQuery: defaultQuery, columns: columns, search: search, actionApi: actionApi })" @confirm="onAddDialogConfirm" multiple />
  </el-form>
</template>
<script>
import viewMiXin from '@/utils/view-mixin.js';
import { goodsApi, orderApi, funConfigApi } from '@/api';
import BjUpload from '@/components/BjUpload/index';
import {  CSG_RETURN_LIST_ADMIN_STATUS } from '@/utils/constants';

export default {
    name: 'BusinessAfterReturnConfim',
    components: {
        BjUpload,
    },
    mixins: [viewMiXin],
    data() {
        return {
            CSG_RETURN_LIST_ADMIN_STATUS,
            colSpan: 8,
            form: {
                customName: this.$store.getters.userInfo.loginName || null,
                logisticsNumber: null,
                associatedCode: null,
                clientCode:  this.$store.getters.userInfo.clientCode || null,
                applySkuList: [],
                cusId: this.$store.getters.cusId || null,
                materialList: []
            },
            actionApi: goodsApi.getSku,
            defaultQuery: {
                status: [1, 2, 3, 4, 5]
            },
            columns: [
                {
                    prop: 'skuCode',
                    label: 'BjDialogListConfig.SKUcode',
                    width: 160,
                },
                {
                    prop: 'skuName',
                    label: 'BjDialogListConfig.SKUname',
                    width: 160,
                },
                {
                    prop: 'barCode',
                    label: this.$t('BusinessPurchaseDetailPage.table.Barcode'),
                    width: 160,
                },
            ],
            search: [
                {
                    placeholder: `${this.$t('BjDialogListConfig.entername')}、${this.$t('BjDialogListConfig.Codes')}、${this.$t('BusinessPurchaseDetailPage.table.Barcode')}`,
                    key: 'keyword',
                },
            ],
            rules: {
                'cusName': [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
            },
            config:{
                nonDefectiveHandling: '',
                defectiveHandling: '',
                showPhoto: true
            }
        };
    },
    computed: {
      clientCodeList() {
        return this.$store.getters.clientCodeList;
      }
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            orderApi.detail({ returnInfoId: this.$route.query.id }).then(res => {
                if(res.confirmSkuList.length == 0){
                  res.confirmSkuList = res.applySkuList
                }
                this.form = res;
                this.$refs.BjUpload.fileList = res.materialList.map(item => {
                  return { name : item.detailImage, url: item.detailImage}
                })
                
                funConfigApi.queryUserConfiguration({clientCode: this.form.clientCode}).then(res=>{
                    if(res.length>0){
                        res.forEach(item =>{
                            if(item.configKey == "How to Handle Non-Conforming Products"){
                                this.config.defectiveHandling = String(item.configValue)
                            }else if(item.configKey == "How to handle quality products"){
                                this.config.nonDefectiveHandling = String(item.configValue)
                            }else if(item.configKey == "Is a photo required"){
                                this.config.showPhoto = !!item.configValue
                            }
                        })
                    }else{
                        this.$message.warning('The Return function is not configured by the customer')
                    }
                })
            });
        },
        async onAddDialogConfirm(data) {
            if (!data) return;
            data.forEach(async(item) => {
                if (!this.form.confirmSkuList.find(ee => ee.sku == item.skuCode)) {
                    this.form.confirmSkuList.push({
                        sku: item.skuCode,
                        standardSkuCode: item.standardSkuCode,
                        barCode: item.barCode,
                        returnTotal: 0,
                        nonDefectiveHandling: this.config.nonDefectiveHandling,
                        defectiveHandling: this.config.defectiveHandling,
                        nonDefectiveNumber: '',
                        defectiveNumber: '',
                    });
                }
            });
        },
        handleShowFnForDialogSkuList() {
            if (this.form.cusId) {
                this.defaultQuery['cusId'] = this.form.cusId;
                this.$nextTick(() => {
                    this.$refs.dialogList.show();
                });
            }
            else {
                this.$message.warning(this.$t('BusinessAfterCsgReturn.hintMessageText1'));
            }
        },
        onDelete(index) {
            this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
                confirmButtonText: this.$t('toast.okText'),
                cancelButtonText: this.$t('toast.cancelText'),
                type: 'warning',
            }).then(() => {
                this.form.confirmSkuList.splice(index, 1)
            })
        },
        afterUpload(url) {
            this.form.materialList.push({ detailImage: url });
        },
        onRemoveUrl(file) {
            this.form.materialList.splice(
                this.form.materialList.findIndex(e => e.detailImage === file.url),
                1,
            );
        },

        onConfirm() {
            if (this.form.confirmSkuList.length == 0) return this.$message.error(this.$t('BusinessAfterCsgReturn.hintMessageText2'));
            for (const item of this.form.confirmSkuList) {
              if ((item.nonDefectiveNumber == 0 && item.defectiveNumber == 0) || (!item.nonDefectiveNumber && !item.defectiveNumber)) {
                return this.$message.error(this.$t('BusinessAfterCsgReturn.hintMessageText4'));
              }
            }
            if(this.config.showPhoto && this.form.materialList.length!=3) return this.$message.error(this.$t('BusinessAfterCsgReturn.imgTip'))
            this.form.confirmSkuList.forEach(item=>{
              if(!item.nonDefectiveNumber){
                item.nonDefectiveNumber = 0
              }else if(!item.defectiveNumber){
                item.defectiveNumber = 0
              }
            })
            orderApi.confirm(this.form).then(res => {
                if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
                    this.$message.success(this.$t('toast.operationSuccessText'));
                    setTimeout(() => {
                        this.complete('BusinessOpenReturnList');
                    }, 500);
                }
            });
        },
    },
};
</script>
